import { z } from 'zod';

import { momentFromDate, momentFromStr } from './datetimes/misc';
import { axleTimeFromStr } from './datetimes/time';

export const zodDateString = () => z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
export const zodDate = () => zodDateString().transform(momentFromStr);

/**
 * JS `new Date()` cannot parse ISO 8601 strings whose UTC offset includes a
 * seconds component (e.g. "0205-06-03T08:15:22-05:44:38"). The backend emits
 * these LMT offsets when localizing pre-1883 datetimes (which occur when a
 * year is mistyped), so truncate the offset's seconds to keep the value
 * parseable instead of failing the whole response schema.
 */
const truncateUtcOffsetSeconds = (value: unknown) =>
    typeof value === 'string' ? value.replace(/([+-]\d{2}:\d{2}):\d{2}$/, '$1') : value;

export const zodDatetime = () =>
    z.preprocess(truncateUtcOffsetSeconds, z.coerce.date()).transform(momentFromDate);
export const zodTime = () => z.coerce.string().time().transform(axleTimeFromStr);
